import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { updateMetaTags } from '../utils/seo'

const MacBookRegensburgPage: React.FC = () => {
  const navigate = useNavigate()
  const go = (path: string) => { navigate(path); setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 50) }

  useEffect(() => {
    updateMetaTags({
      title: 'MacBook Reparatur Regensburg – PhoneMedic | ab 119€',
      description: 'MacBook Reparatur Regensburg ✓ Platinen-Reparatur ✓ Display ✓ Akku ✓ Wasserschaden ✓ ab 119€ ✓ Auch bundesweiter Einsende-Service ✓ 12 Monate Garantie | PhoneMedic',
      keywords: ['MacBook Reparatur Regensburg', 'MacBook Reparatur Regensburg Preise', 'Laptop Reparatur Regensburg', 'MacBook startet nicht Regensburg', 'Apple Reparatur Regensburg'],
      canonicalUrl: 'https://www.phone-medic.de/macbook-reparatur-regensburg',
    })

    const schema = [
      {
        '@context': 'https://schema.org',
        '@type': 'LocalBusiness',
        name: 'PhoneMedic – MacBook Reparatur Regensburg',
        description: 'MacBook Reparatur in Regensburg und bundesweit per Einsende-Service. Spezialist für Platinen-Reparatur, Wasserschäden und Mikrochip-Löten.',
        url: 'https://www.phone-medic.de',
        telephone: '+491605010907',
        email: 'service@phone-medic.de',
        address: {
          '@type': 'PostalAddress',
          streetAddress: 'Wahlenstraße 27',
          postalCode: '93047',
          addressLocality: 'Regensburg',
          addressRegion: 'Bayern',
          addressCountry: 'DE',
        },
        geo: {
          '@type': 'GeoCoordinates',
          latitude: 49.01868333954896,
          longitude: 12.095426035934995,
        },
        areaServed: [
          { '@type': 'City', name: 'Regensburg' },
          { '@type': 'Country', name: 'Germany' },
        ],
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: '4.9',
          reviewCount: '32',
          bestRating: '5',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: 'Habt ihr einen Laden in Regensburg?',
            acceptedAnswer: { '@type': 'Answer', text: 'PhoneMedic ist in Regensburg ansässig, aber kein klassisches Ladenlokal mit Laufkundschaft. Reparaturen werden ausschließlich per Einsende-Service abgewickelt. Du schickst dein MacBook ein, wir reparieren es und schicken es zurück.' },
          },
          {
            '@type': 'Question',
            name: 'Kann ich mein MacBook in Regensburg persönlich abgeben?',
            acceptedAnswer: { '@type': 'Answer', text: 'Momentan arbeiten wir ausschließlich mit dem Einsende-Service. Du erhältst ein kostenloses DHL-Versandlabel und kannst dein Gerät bequem von zu Hause aus einsenden – egal ob aus Regensburg, Bayern oder deutschlandweit.' },
          },
          {
            '@type': 'Question',
            name: 'Was kostet MacBook Reparatur in Regensburg?',
            acceptedAnswer: { '@type': 'Answer', text: 'Diagnose ab 24,95€, Platinen-Reparatur ab 119€, Display-Tausch ab 229€, Akku-Tausch ab 129€. Alle Preise inklusive 12 Monate Garantie und kostenlosem Rückversand.' },
          },
          {
            '@type': 'Question',
            name: 'Wie lange dauert die Reparatur?',
            acceptedAnswer: { '@type': 'Answer', text: 'Standard-Reparaturen (Display, Akku) dauern 2–3 Werktage. Platinen-Reparaturen 3–5 Werktage. Inklusive Versand (Hin und zurück) rechne mit 5–8 Werktagen.' },
          },
        ],
      },
    ]

    let script = document.querySelector('#macbook-regensburg-schema') as HTMLScriptElement
    if (!script) {
      script = document.createElement('script')
      script.id = 'macbook-regensburg-schema'
      script.type = 'application/ld+json'
      document.head.appendChild(script)
    }
    script.textContent = JSON.stringify(schema)
    return () => { document.querySelector('#macbook-regensburg-schema')?.remove() }
  }, [])

  const services = [
    { icon: '🔬', title: 'Platinen-Reparatur', desc: 'Chip-Level Reparatur für MacBooks die nicht starten, Wasserschäden oder Kurzschlüsse haben.', price: 'ab 119 €', path: '/macbook-startet-nicht' },
    { icon: '💧', title: 'Wasserschaden', desc: 'Professionelle Platinen-Reinigung und Reparatur nach Flüssigkeitsschäden. Erfolgsquote 70–90 %.', price: 'ab 119 €', path: '/macbook-wasserschaden' },
    { icon: '🖥️', title: 'Display Reparatur', desc: 'Gesprungenes oder schwarzes Display tauschen. Retina & Liquid Retina XDR alle Modelle.', price: 'ab 229 €', path: '/macbook-display-reparatur' },
    { icon: '🔋', title: 'Akku Austausch', desc: 'MacBook Air und Pro Akku tauschen. Alle Modelle, original Qualität, schnelle Abwicklung.', price: 'ab 129 €', path: '/macbook-akku-tauschen' },
    { icon: '⌨️', title: 'Tastatur / Topcase', desc: 'Defekte Tasten oder klebende Tastatur? Topcase-Tausch für alle MacBook Generationen.', price: 'ab 129 €', path: '/macbook-reparatur' },
    { icon: '🔌', title: 'Ladeport / USB-C', desc: 'MacBook lädt nicht? Defekter USB-C Ladeport tauschen – schnell und günstig.', price: 'ab 79 €', path: '/macbook-reparatur' },
  ]

  const faqs = [
    { q: 'Habt ihr einen Laden in Regensburg?', a: 'PhoneMedic ist in Regensburg ansässig, aber kein klassisches Ladenlokal. Reparaturen werden ausschließlich per Einsende-Service abgewickelt.' },
    { q: 'Kann ich mein MacBook persönlich abgeben?', a: 'Momentan arbeiten wir ausschließlich mit dem Einsende-Service. Du erhältst ein kostenloses DHL-Label und kannst dein Gerät bequem einsenden.' },
    { q: 'Was kostet MacBook Reparatur in Regensburg?', a: 'Diagnose ab 24,95€, Platinen-Reparatur ab 119€, Display-Tausch ab 229€, Akku-Tausch ab 129€. Alle Preise inkl. 12 Monate Garantie.' },
    { q: 'Wie lange dauert die Reparatur?', a: 'Standard-Reparaturen 2–3 Werktage, Platinen-Reparaturen 3–5 Werktage. Inklusive Versand ca. 5–8 Werktage.' },
    { q: 'Welche MacBook Modelle werden repariert?', a: 'Alle MacBook Modelle: MacBook Air M1/M2/M3, MacBook Pro 13/14/16 Zoll M1 bis M4, sowie alle Intel MacBooks. Auch iMac Logicboard-Reparaturen.' },
    { q: 'Gibt es eine Garantie auf die Reparatur?', a: 'Ja. 12 Monate Garantie auf alle Reparaturen. Wenn das gleiche Problem innerhalb eines Jahres wieder auftritt, reparieren wir kostenfrei.' },
  ]

  return (
    <div className="min-h-screen bg-white">
      <section
        className="relative text-white py-20"
        style={{ backgroundImage: 'url(/hero-bg.webp)', backgroundSize: 'cover', backgroundPosition: 'center top' }}
      >
        <div className="absolute inset-0 bg-gray-900/80" />
        <div className="relative max-w-7xl mx-auto px-4">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 bg-indigo-600/20 border border-indigo-500/30 text-indigo-300 text-sm font-medium px-3 py-1 rounded-full mb-6">
              <span className="w-1.5 h-1.5 bg-indigo-400 rounded-full"></span>
              Regensburg · Bundesweiter Einsende-Service
            </div>
            <h1 className="text-5xl font-bold mb-6 leading-tight">
              MacBook Reparatur Regensburg –<br />
              <span className="text-indigo-400">PhoneMedic</span>
            </h1>
            <p className="text-xl text-gray-300 mb-8 max-w-2xl">
              Spezialist für MacBook Reparatur in Regensburg und deutschlandweit. Platinen-Reparatur, Display, Akku – professionell, fair bepreist, mit 12 Monaten Garantie.
            </p>
            <div className="flex flex-wrap gap-4">
              <a href="mailto:service@phone-medic.de" className="bg-indigo-600 text-white px-7 py-3.5 rounded-lg font-semibold hover:bg-indigo-700 transition-colors">
                Reparatur anfragen
              </a>
              <a href="https://wa.me/491605010907" target="_blank" rel="noopener noreferrer" className="bg-white/10 text-white border border-white/20 px-7 py-3.5 rounded-lg font-semibold hover:bg-white/20 transition-colors">
                WhatsApp
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-gray-800 text-white py-5 border-t border-gray-700">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
            {[
              { number: '4,9 ★', label: '32 Google-Bewertungen' },
              { number: 'ab 119 €', label: 'Platinen-Reparatur' },
              { number: '12 Monate', label: 'Garantie' },
              { number: 'Bundesweit', label: 'Einsende-Service' },
            ].map((s, i) => (
              <div key={i}>
                <div className="text-2xl font-bold text-indigo-400">{s.number}</div>
                <div className="text-sm text-gray-400">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-3">MacBook Reparatur Services in Regensburg</h2>
            <p className="text-gray-500">Alle Reparaturen – Einsende-Service bundesweit</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map((s, i) => (
              <div
                key={i}
                className="bg-white rounded-xl border border-gray-200 p-6 flex flex-col hover:shadow-md transition-shadow cursor-pointer"
                onClick={() => go(s.path)}
              >
                <h3 className="font-bold text-gray-900 mb-2">{s.title}</h3>
                <p className="text-sm text-gray-500 flex-1 mb-4">{s.desc}</p>
                <div className="flex items-center justify-between">
                  <span className="font-bold text-indigo-600">{s.price}</span>
                  <span className="text-sm text-indigo-600 font-medium">Mehr →</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Einsende-Service – So funktioniert's</h2>
              <p className="text-gray-600 mb-6 leading-relaxed">
                PhoneMedic ist in Regensburg (Bayern) ansässig. Da wir auf komplexe Reparaturen spezialisiert sind, arbeiten wir ausschließlich mit dem Einsende-Service. So können wir dir den besten Preis und die beste Qualität bieten – ohne Ladenmiete, die du mitbezahlen müsstest.
              </p>
              <ol className="space-y-4">
                {[
                  { step: '1', title: 'Kontakt aufnehmen', desc: 'Per E-Mail oder WhatsApp. Du erhältst sofort ein kostenloses DHL-Versandlabel.' },
                  { step: '2', title: 'MacBook einsenden', desc: 'Sicher verpacken und mit dem kostenlosen Label einsenden. Wir bestätigen den Eingang.' },
                  { step: '3', title: 'Diagnose & Angebot', desc: 'Wir analysieren dein MacBook und senden dir einen verbindlichen Kostenvoranschlag.' },
                  { step: '4', title: 'Reparatur & Rücksendung', desc: 'Nach deiner Freigabe reparieren wir es und schicken es versichert zurück.' },
                ].map((item) => (
                  <li key={item.step} className="flex gap-4">
                    <div className="w-10 h-10 bg-gray-900 text-white rounded-full flex items-center justify-center font-bold shrink-0">{item.step}</div>
                    <div>
                      <div className="font-bold text-gray-900">{item.title}</div>
                      <div className="text-sm text-gray-500">{item.desc}</div>
                    </div>
                  </li>
                ))}
              </ol>
            </div>
            <div className="bg-gray-50 rounded-xl border border-gray-200 p-6">
              <h3 className="font-bold text-gray-900 mb-4">Kontakt</h3>
              <div className="space-y-3">
                <a href="https://wa.me/491605010907" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-gray-600 hover:text-gray-900 transition-colors text-sm">
                  WhatsApp: 0160-5010907
                </a>
                <a href="mailto:service@phone-medic.de" className="flex items-center gap-3 text-gray-600 hover:text-gray-900 transition-colors text-sm">
                  service@phone-medic.de
                </a>
                <div className="text-gray-600 text-sm">
                  Regensburg, Bayern (kein Ladenlokal)
                </div>
              </div>
              <div className="mt-6 p-4 bg-indigo-50 border border-indigo-200 rounded-lg">
                <p className="text-sm text-indigo-800">
                  <strong>Bundesweit verfügbar.</strong> Kunden aus ganz Deutschland senden ihre MacBooks ein – von Hamburg bis München, von Berlin bis Köln.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-gray-50">
        <div className="max-w-3xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-10">Häufige Fragen</h2>
          <div className="space-y-4">
            {faqs.map((faq, i) => (
              <div key={i} className="bg-white border border-gray-200 rounded-xl p-6">
                <h3 className="font-semibold text-gray-900 mb-2">{faq.q}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{faq.a}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-gray-900 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-3">MacBook Reparatur in Regensburg anfragen</h2>
          <p className="text-gray-400 mb-8">Kostenloser Versand · 12 Monate Garantie · Kostenvoranschlag vor Reparaturbeginn</p>
          <div className="flex flex-wrap justify-center gap-4">
            <a href="mailto:service@phone-medic.de" className="bg-indigo-600 text-white px-7 py-3.5 rounded-lg font-semibold hover:bg-indigo-700 transition-colors">
              Per E-Mail anfragen
            </a>
            <a href="https://wa.me/491605010907" target="_blank" rel="noopener noreferrer" className="bg-white text-gray-900 px-7 py-3.5 rounded-lg font-semibold hover:bg-gray-100 transition-colors">
              WhatsApp
            </a>
          </div>
        </div>
      </section>
    </div>
  )
}

export default MacBookRegensburgPage
